import { createFeatureSelector, createSelector } from '@ngrx/store';
import { JournalViewColumnViewModelStates } from '../states';
import { columnViewModelFeatureKey1 } from '../reducers/root';
export const ViewModelSelector = createFeatureSelector<JournalViewColumnViewModelStates>(columnViewModelFeatureKey1);
export const selectGenericDocJournalListing_State = createSelector(
  ViewModelSelector, 
 (state: JournalViewColumnViewModelStates) => state.column1ViewModel.genericDocJournalListingState
);